import { parseNumberInput } from './numberUtils';
import { Money } from '../api-types/common';

export function getExponent(currency: string) {
  switch (currency) {
    case 'JPY':
      return 0;
    default:
      return 2;
  }
}

export function convertMonetaryIntToDecimal(value: number, currency: string): number {
  const exponent = getExponent(currency);
  return value / 10 ** exponent;
}

export function convertMonetaryDecimalToInt(value: number, currency: string): number {
  const exponent = getExponent(currency);
  const intValue = value * 10 ** exponent;
  return Math.round(intValue); // Fix floating point errors
}

export function convertMoneyToDecimal({ amount, currency }: Money): number {
  return convertMonetaryIntToDecimal(amount, currency);
}

export function convertDecimalToMoney(value: number, currency: string): Money {
  return { amount: convertMonetaryDecimalToInt(value, currency), currency };
}

export function formatMoney(locale: string, money: Money | null | undefined): string {
  if (!money || !money.currency || typeof money.amount !== 'number') return '';
  const { amount, currency } = money;
  const value = convertMonetaryIntToDecimal(amount, currency);
  const exponent = getExponent(currency);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: exponent,
  }).format(value);
}

export function formatMoneyInput(locale: string, money: Money | null | undefined): string {
  if (!money) return '';
  const { amount, currency } = money;
  const value = convertMonetaryIntToDecimal(amount, currency);
  const exponent = getExponent(currency);
  return new Intl.NumberFormat(locale, {
    useGrouping: false,
    minimumFractionDigits: exponent,
  }).format(value);
}

export function formatCurrencySymbol(locale: string, currency: string): string {
  return (
    new Intl.NumberFormat(locale, { style: 'currency', currency })
      .formatToParts(1)
      .find((part) => part.type === 'currency')?.value ?? ''
  );
}

export function parseMoneyInput(value: string, currency: string) {
  return convertDecimalToMoney(parseNumberInput(value), currency);
}
